module.exports = __webpack_public_path__ + "static/img/chatBot.f4b9aea8.svg";